/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceSummary } from './InvoiceSummary';
import {
    InvoiceSummaryFromJSON,
    InvoiceSummaryFromJSONTyped,
    InvoiceSummaryToJSON,
    InvoiceSummaryToJSONTyped,
} from './InvoiceSummary';

/**
 * 
 * @export
 * @interface PagedAndSyncedResultInvoiceSummary
 */
export interface PagedAndSyncedResultInvoiceSummary {
    /**
     * 
     * @type {Array<InvoiceSummary>}
     * @memberof PagedAndSyncedResultInvoiceSummary
     */
    content: Array<InvoiceSummary>;
    /**
     * 
     * @type {number}
     * @memberof PagedAndSyncedResultInvoiceSummary
     */
    totalElements: number;
    /**
     * 
     * @type {number}
     * @memberof PagedAndSyncedResultInvoiceSummary
     */
    totalPages: number;
    /**
     * 
     * @type {Date}
     * @memberof PagedAndSyncedResultInvoiceSummary
     */
    lastSyncedAt?: Date;
}

/**
 * Check if a given object implements the PagedAndSyncedResultInvoiceSummary interface.
 */
export function instanceOfPagedAndSyncedResultInvoiceSummary(value: object): value is PagedAndSyncedResultInvoiceSummary {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('totalElements' in value) || value['totalElements'] === undefined) return false;
    if (!('totalPages' in value) || value['totalPages'] === undefined) return false;
    return true;
}

export function PagedAndSyncedResultInvoiceSummaryFromJSON(json: any): PagedAndSyncedResultInvoiceSummary {
    return PagedAndSyncedResultInvoiceSummaryFromJSONTyped(json, false);
}

export function PagedAndSyncedResultInvoiceSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedAndSyncedResultInvoiceSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'content': ((json['content'] as Array<any>).map(InvoiceSummaryFromJSON)),
        'totalElements': json['totalElements'],
        'totalPages': json['totalPages'],
        'lastSyncedAt': json['lastSyncedAt'] == null ? undefined : (new Date(json['lastSyncedAt'])),
    };
}

export function PagedAndSyncedResultInvoiceSummaryToJSON(json: any): PagedAndSyncedResultInvoiceSummary {
    return PagedAndSyncedResultInvoiceSummaryToJSONTyped(json, false);
}

export function PagedAndSyncedResultInvoiceSummaryToJSONTyped(value?: PagedAndSyncedResultInvoiceSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': ((value['content'] as Array<any>).map(InvoiceSummaryToJSON)),
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
        'lastSyncedAt': value['lastSyncedAt'] == null ? value['lastSyncedAt'] : value['lastSyncedAt'].toISOString(),
    };
}

